/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_Negotiate_Mistakes_TitleInputs */

const en_salary_negotiate_mistakes_title = /** @type {(inputs: Salary_Negotiate_Mistakes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Common Mistakes`)
};

const de_salary_negotiate_mistakes_title = /** @type {(inputs: Salary_Negotiate_Mistakes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Häufige Fehler`)
};

const fr_salary_negotiate_mistakes_title = /** @type {(inputs: Salary_Negotiate_Mistakes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreurs courantes`)
};

const es_salary_negotiate_mistakes_title = /** @type {(inputs: Salary_Negotiate_Mistakes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errores comunes`)
};

const it_salary_negotiate_mistakes_title = /** @type {(inputs: Salary_Negotiate_Mistakes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errori comuni`)
};

const nl_salary_negotiate_mistakes_title = /** @type {(inputs: Salary_Negotiate_Mistakes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Veelgemaakte fouten`)
};

const pl_salary_negotiate_mistakes_title = /** @type {(inputs: Salary_Negotiate_Mistakes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Częste błędy`)
};

const fi_salary_negotiate_mistakes_title = /** @type {(inputs: Salary_Negotiate_Mistakes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yleiset virheet`)
};

const da_salary_negotiate_mistakes_title = /** @type {(inputs: Salary_Negotiate_Mistakes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almindelige fejl`)
};

const sv_salary_negotiate_mistakes_title = /** @type {(inputs: Salary_Negotiate_Mistakes_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vanliga misstag`)
};

/**
* | output |
* | --- |
* | "Common Mistakes" |
*
* @param {Salary_Negotiate_Mistakes_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_negotiate_mistakes_title = /** @type {((inputs?: Salary_Negotiate_Mistakes_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_Negotiate_Mistakes_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_negotiate_mistakes_title(inputs)
	if (locale === "fr") return fr_salary_negotiate_mistakes_title(inputs)
	if (locale === "es") return es_salary_negotiate_mistakes_title(inputs)
	if (locale === "it") return it_salary_negotiate_mistakes_title(inputs)
	if (locale === "nl") return nl_salary_negotiate_mistakes_title(inputs)
	if (locale === "pl") return pl_salary_negotiate_mistakes_title(inputs)
	if (locale === "fi") return fi_salary_negotiate_mistakes_title(inputs)
	if (locale === "da") return da_salary_negotiate_mistakes_title(inputs)
	if (locale === "sv") return sv_salary_negotiate_mistakes_title(inputs)
	return en_salary_negotiate_mistakes_title(inputs)
});